export const storage = {
	get(key: string) {
		const target = localStorage.getItem(key);
		if (target) {
			try {
				const obj = JSON.parse(target);
				return obj.data;
			} catch (e) {
				return target;
			}
		}
		return target;
	},
	set(key: string, data: any) {
		localStorage.setItem(key, JSON.stringify({ data }));
	},
};

/** 用户账号UID */
export const S_UID = 'S_DH_UID';
/** JWT */
export const S_AUTH_TOKEN = 'S_DH_AUTH_TOKEN';
/** 最近登录时间 */
export const S_LATEST_LOGIN_TIME = 'S_DH_LATEST_LOGIN_TIME';
/** 用户手机号 */
export const S_UPHONE = 'S_DH_UPHONE';
